import React, { useState } from "react";
import { Button, Input, MenuSelect } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
	const [language, setLanguage] = React.useState("Language");
	const [form, setForm] = useState();
	const navigate = useNavigate();
	const data = [
		{ title: "English", onClick: () => setLanguage("English") },
		{ title: "French", onClick: () => setLanguage("French") },
		{ title: "Spanish", onClick: () => setLanguage("Spanish") },
		{ title: "Portuguese", onClick: () => setLanguage("Portuguese") }
	];

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// Form submission
	};

	return (
		<div className="flex flex-col w-full h-screen items-center justify-center bg-dry">
			<form className="grid grid-cols-12 w-auto min-w-96 min-h-[25rem] shadow-2xl  mx-auto mb-6 bg-white" onSubmit={handleSubmit}>
				<div className="flex flex-col items-center justify-center col-span-5 bg-subMain p-8 ">
					<img src="/images/logo.png" alt="logo" className="w-48 h-16 object-contain" />
					<MenuSelect className={"text-center mt-1 p-2 border rounded-lg"} datas={data}>
						<div className="text-white">{language}</div>
					</MenuSelect>
				</div>
				<div className="flex flex-col items-center justify-center col-span-7 p-8">
					<div className="flex flex-col w-full mb-3">
						<div className="text-xl text-center mb-2">Forgot your password?</div>
						<Input className={"mb-0"} type="email" color placeholder={"Email"} name={"email"} onChange={handleChange} />
					</div>
					<Button
						label="SEND RESET PASSWORD EMAIL"
						Icon={BiLogInCircle}
						type="submit"
					/>
					<Button className={"w-full bg-transparent !text-subMain"} label={"GO TO LOGIN"} onClick={() => navigate("/login")} />
				</div>
			</form>
		</div>
	);
}

export default ForgotPassword;
